import {
  GET_HEALTH_STATUS_BUMI_SERVICE,
  GET_HEALTH_STATUS_BUMI_SERVICE_SUCCESS,
  GET_HEALTH_STATUS_BUMI_SERVICE_ERROR,
  InitialState,
  HealthStatusActions,
  HealthStatusState,
} from './types'
import { status } from '../../typeStatus'

const HealthStatusReducer = (
  state: HealthStatusState = InitialState,
  action: HealthStatusActions
): HealthStatusState => {
  switch (action.type) {
    case GET_HEALTH_STATUS_BUMI_SERVICE: {
      return {
        ...state,
        response: null,
        status: status.loading,
      }
    }
    case GET_HEALTH_STATUS_BUMI_SERVICE_SUCCESS: {
      return {
        ...state,
        response: action.payload,
        status: status.success,
      }
    }
    case GET_HEALTH_STATUS_BUMI_SERVICE_ERROR: {
      return {
        ...state,
        response: null,
        status: status.error,
      }
    }

    default:
      return state
  }
}

export default HealthStatusReducer
